<template>
  <div class="app-container" v-loading="loading">
    <div class="client_img">
      <img :src="require(`@/assets/img/${theme[init.ui_type].imgUrl}/Syg_icon_sdfsdfsdf.png`)">
    </div>
    <a v-if="cusContent.live_url" @click="goWeb(cusContent.live_url)" class="btn_plain" :style="`color: ${themeConfig.dark}; border-color: ${themeConfig.dark}`">点击联系客服</a>
    <div class="footer_links" v-if="cusContent.telephone" :style="isHorizontal ? 'left: 20%;' : null">客服热线：<a :href='`tel:${cusContent.telephone}`'>{{cusContent.telephone}}</a></div>
  </div>
</template>
<script>
import { getCustomerInfo } from '@/api/status'
import { newPromise } from '@/utils'
import { mapGetters } from 'vuex'
export default {
  name: 'Customer',
  data () {
    return {
      loading: false,
      content: {
        live_url: '',
        telephone: ''
      }
    }
  },
  computed: {
    ...mapGetters([
      'themeConfig',
      'isHorizontal',
      'theme',
      'init',
      'cusContent',
      'cusStatus'
    ])
  },
  mounted () {
    if (!this.cusStatus) {
      this.getItem()
    }
  },
  methods: {
    async getItem () {
      this.loading = true
      const res = await newPromise(getCustomerInfo)
      this.loading = false
      if (res.error_code) {
        this.$toast.error(res.msg ? res.msg : '请求错误')
      } else {
        this.$store.commit('SET_CUSCONTENT', res.data)
        this.$store.commit('SET_CUSSTATUS', true)
      }
    },
    goWeb (url) {
      // 购买的包跳转外部链接
      if (typeof window.ios_jumpstore === 'function') {
        return window.ios_jumpstore(url)
      } else if (typeof window.webkit !== 'undefined' && typeof window.webkit.messageHandlers.ios_jumpstore === 'object') {
        return window.webkit.messageHandlers.ios_jumpstore.postMessage(url)
      } else if (typeof window.initGameCall === 'function') {
        return window.initGameCall(url)
      } else if (typeof window.webkit !== 'undefined' && typeof window.webkit.messageHandlers.initGameCall === 'object') {
        return window.webkit.messageHandlers.initGameCall.postMessage(url)
      } else if (typeof window.TWHFiOSClickOtherBtn === 'function') {
        return window.TWHFiOSClickOtherBtn(url)
      } else if (typeof window.webkit !== 'undefined' && typeof window.webkit.messageHandlers.TWHFiOSClickOtherBtn === 'object') {
        return window.webkit.messageHandlers.TWHFiOSClickOtherBtn.postMessage(url)
      }
      window.location.href = url
    }
  }
}
</script>

<style lang="less" scoped>
.app-container {
  overflow: hidden;
  position: relative;
}
.client_img {
  margin: .6rem auto .5rem;
  width: 2.4rem;
  img {
    display: block;
    width: 100%;
  }
}
.btn_plain {
  border: 1.45px solid;
  border-radius: .1rem;
  font-size: .24rem;
  line-height: .7rem;
  width: 2.3rem;
  margin: 0.3rem auto;
  text-align: center;
  display: block;
}
.footer_links {
  position: fixed;
  bottom: .6rem;
  left: 0;
  right: 0;
  color: #46aff1;
  text-align: center;
  font-size: .18rem;
  a {
    color: #46aff1;
  }
}
</style>
